import _ from "lodash";
import moment from "moment";
import qs from "qs";
import * as deepmerge from "deepmerge";
import Handlebars from "handlebars/dist/handlebars.min";

import PlayerPaths from "../constants/paths/playerPaths";
import historyActions from "./historyActions";
// import * as inventoryActions from "./inventoryActions";
// import * as navActions from "./navActions";
// import * as awsS3 from "../persistence/s3";
// import * as algolia from "../search/algolia";
import { getActivityItemHistoryPath, mcMoment } from "../utils/utils";
// import env from "../constants/env";
import { showError, showWarning, showConfirm, showAlert } from "./alertActions";
import { setCompletionState } from "../actions/completionActions";
import state from "../state";
import { generateUUID/*, getActivityLastUpdatedDateTime, createActivitySessionListItem, normalizeActivity*/, initializeIdsAndVariableState, getActivityMetaData } from "../utils/utils";
import { initializeOrchestrator, setValueIfHasIdOrchestratedSync } from "./orchestrationActions";
import RuntimeApi from "../runtimeEngine/runtimeApi";
import * as Utils from "../utils/utils";
import { transformToActivityPlayer/*, transformFromActivityPlayer*/ } from "../utils/transformUtils";
import ambifi from "../ambifi";
import PersistenceManagerFactory from "../persistence/PersistenceManagerFactory";
import { injectCustomStyling } from "../utils/config";
import config from "../config/config";
import env from "../constants/env";
import { initializeDrive } from "./drive";

import themes from "../constants/themes";


//TODO: This needs to come from JSON file
const ACTIVITY_NO_CONTENT_ERROR_MESSAGE = "This activity does not have any content. You need at least one Item. It can't be displayed.";

export function handleChangePropertyDisconnected(tree, listIndex, sectionIndex, itemIndex, name, value) {
	tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, itemIndex, name), value);
	saveLastItemValue(tree, value);
	tree.commit();
}

export function handleChangeProperty(tree, listIndex, sectionIndex, itemIndex, name, value) {

	if (name !== "value") {
		handleChangePropertyDisconnected(tree, listIndex, sectionIndex, itemIndex, name, value);
	} else {
		let item = tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, itemIndex));
		console.log("IFTTT VARIABLE VALUE SET REQUEST - handleChangeProperty");
		setValueIfHasIdOrchestratedSync(item, value).then(() => {

			tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, itemIndex, name), value);

			ambifi.persistenceManager.saveResponse(tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, itemIndex)));

			saveLastItemValue(tree, value);
			tree.commit();

			// Moved this down as it might be looking at the node value
			if (item.hasOwnProperty("valueTrigger") && item.valueTrigger !== "") {
				// Inject global procedure functions	
				let strfun = tree.get(PlayerPaths.ACTIVITY_PROPERTY("functions"));
				let strEval = item.valueTrigger;
				if (!_.isEmpty(strfun)) {
					strEval = strfun + "\n" + item.valueTrigger;
				}

				let AmbiFi = RuntimeApi; // eslint-disable-line
				var af = RuntimeApi; // eslint-disable-line
				var afState = state; // eslint-disable-line
				var afUtils = Utils; // eslint-disable-line
				var afAlert = showAlert; // eslint-disable-line
				eval(strEval);// eslint-disable-line

				//tree.set(["session"], tree.get(["session"]) + 1);
			}
		});
	}
}

// TODO: UGLY...re-think
export function saveLastItemValue(tree, value) {
	tree.set(["lastItemValue"], value);
}

export function setItemChecked(tree, listIndex, sectionIndex, itemIndex, checked, identityId, linkOnCheck, linkId, linkActionType) {
	setSelectedItem(tree, listIndex, sectionIndex, itemIndex, false);

	const path = getActivityItemHistoryPath(listIndex, sectionIndex, itemIndex);

	let item = tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, itemIndex));

	if (item.enabled) {
		tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, itemIndex, "checked"), checked);
		tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, itemIndex, "value"), checked);

		ambifi.persistenceManager.saveResponse(tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, itemIndex)));

		setValueIfHasIdOrchestratedSync(item, checked).then(() => {
			if (checked) {

				if (item.hasOwnProperty("valueTrigger") && item.valueTrigger !== "") {
					// Inject global procedure functions
					let strfun = tree.get(PlayerPaths.ACTIVITY_PROPERTY("functions"));
					let strEval = item.valueTrigger;
					if (!_.isEmpty(strfun)) {
						strEval = strfun + "\n" + strEval;
					}

					let AmbiFi = RuntimeApi;// eslint-disable-line
					var af = RuntimeApi; // eslint-disable-line
					var afState = state; // eslint-disable-line
					var afUtils = Utils; // eslint-disable-line
					var afAlert = showAlert; // eslint-disable-line
					eval(strEval);// eslint-disable-line
				}

				// Skip
				if (!itemSelected(tree, listIndex, sectionIndex, itemIndex)) {
					let selectedListIndex = tree.get(PlayerPaths.ACTIVITY_SELECTED_LIST_INDEX);
					let selectedSectionIndex = tree.get(PlayerPaths.ACTIVITY_SELECTED_SECTION_INDEX);
					let selectedItemIndex = tree.get(PlayerPaths.ACTIVITY_SELECTED_ITEM_INDEX);
					historyActions.skipItem(tree, selectedListIndex + "," + selectedSectionIndex + "," + selectedItemIndex, identityId, item);
				}

				historyActions.checkItem(tree, path, identityId, item);

				setCompletionState(tree, listIndex, sectionIndex, itemIndex);
				refreshMandatory(tree);

				if (!item.selected) {
					setSelectedItem(tree, listIndex, sectionIndex, itemIndex, false);
				}


				if (linkOnCheck) {
					linkUrl(tree, linkActionType + ":" + linkId, { listIndex: listIndex, sectionIndex: sectionIndex, itemIndex: itemIndex }, true);
				} else {
					setNextSelected(tree, listIndex, sectionIndex, itemIndex);
					//saveCurrentActivityToStore(tree); 
				}

				/**
				 * 	handleSave() {
		this.props.dispatch(
			playerActions.saveActivity
		);
	}

	handleSaveAndExit() {
		this.props.dispatch(
			playerActions.saveActivityAndExit
		);
	}
				 */

				if (item.hasOwnProperty("saveOnCheck") && item.saveOnCheck) {
					saveActivity(state);
				} else if (item.hasOwnProperty("saveAndExitOnCheck") && item.saveAndExitOnCheck) {
					showConfirm("You are about to be taken back to the home screen, please confirm that this is what you would like to do.", "Leaving Activity", () => {
						saveActivityAndExit();
					});
				}

				if (item.hasOwnProperty("generateReportOnCheck") && item.generateReportOnCheck && ambifi.persistenceManager && _.isFunction(ambifi.persistenceManager.printInstance)) {
					const currentActivity = _.cloneDeep(tree.get(["activity"]));

					let printFilename = "";
					let lastUpdated = "";
					if (currentActivity.history.length > 0) {
						lastUpdated = currentActivity.history[currentActivity.history.length - 1].timestamp;
					}

					if (lastUpdated !== "") {
						printFilename = currentActivity.name + " - " + lastUpdated;

					} else {
						printFilename = currentActivity.name;
					}
					tree.set(PlayerPaths.SHOW_SPINNER, true);
					ambifi.persistenceManager.printInstance(printFilename, currentActivity, item.generateReportOnCheckTemplate
					).then(() => {
						tree.set(PlayerPaths.SHOW_SPINNER, false);
						//hideSpinner
					}).catch(err => {
						tree.set(PlayerPaths.SHOW_SPINNER, false);
						console.error(err);
						showError("Print Report", "An error occurred while attempting to print the report. Error: " + err);
					});
				}
			} else {
				historyActions.uncheckItem(tree, path, identityId, item);

				setCompletionState(tree, listIndex, sectionIndex, itemIndex);
				setSelectedItem(tree, listIndex, sectionIndex, itemIndex, false);
				//saveCurrentActivityToStore(tree);				
			}
		}).catch(err => {
			console.error("Variable state update failed, reason:" + err, err);
		});

	} else {
		showWarning("This item is disabled. Please check the mandatory item prior to this.");
	}
}

export function setNextItemChecked(tree) {
	// console.log(" In " + arguments.callee.name);
	const listIndex = tree.get(["activity", "selected", "listIndex"]);
	const sectionIndex = tree.get(["activity", "selected", "sectionIndex"]);
	const itemIndex = tree.get(["activity", "selected", "itemIndex"]);

	const item = tree.get(["activity", "children", listIndex, "children", sectionIndex, "children", itemIndex]);

	if (item.type === "itemPicker") {
		const linkOnSelect = (item.hasOwnProperty("pickerLinkOnSelect") ? item.pickerLinkOnSelect : false);
		const linkActionType = (item.hasOwnProperty("pickerLinkActionType") ? item.pickerLinkActionType : "goto");

		if (item.value === "") {
			return;
		}
		setItemPickerChecked(tree, listIndex, sectionIndex, itemIndex, linkOnSelect, "", linkActionType);

	} else if (item.type === "itemYesNo") {
		const linkOnSelect = (item.hasOwnProperty("yesNoLinkOnSelect") ? item.yesNoLinkOnSelect : false);
		const linkActionType = (item.hasOwnProperty("yesNoLinkActionType") ? item.yesNoLinkActionType : "goto");
		// const linkYesId = (item.hasOwnProperty("yesNoYesLinkId") ? item.yesNoYesLinkId : "");
		// const linkNoId = (item.hasOwnProperty("yesNoNoLinkId") ? item.yesNoNoLinkId : "");

		if (linkOnSelect && item.value === "") {
			return;
		}
		setItemYesNoChecked(tree, listIndex, sectionIndex, itemIndex, item.value, linkOnSelect, linkActionType);
	} else {
		const linkOnCheck = (item.hasOwnProperty("linkOnCheck") ? item.linkOnCheck : false);
		const linkId = (item.hasOwnProperty("linkId") ? item.linkId : "");
		const linkActionType = (item.hasOwnProperty("linkActionType") ? item.linkActionType : "goto");

		switch (item.type) {
			case "item":
				setItemChecked(tree, listIndex, sectionIndex, itemIndex, true, linkOnCheck, linkId, linkActionType);
				break;
			case "itemChoiceSingle":
				setItemChoiceSingleChecked(tree, listIndex, sectionIndex, itemIndex, linkOnCheck, linkId, linkActionType);
				break;
			case "itemChoiceMulti":
				setItemChoiceMultiChecked(tree, listIndex, sectionIndex, itemIndex, linkOnCheck, linkId, linkActionType);
				break;
			case "itemDate":
				setItemDateChecked(tree, listIndex, sectionIndex, itemIndex, item.value, "date", linkOnCheck, linkId, linkActionType);
				break;
			case "itemTime":
				setItemDateChecked(tree, listIndex, sectionIndex, itemIndex, item.value, "time", linkOnCheck, linkId, linkActionType);
				break;
			case "itemDateTime":
				setItemDateChecked(tree, listIndex, sectionIndex, itemIndex, item.value, "datetime", linkOnCheck, linkId, linkActionType);
				break;
			// case "itemWeather":
			// 	setItemWeatherChecked(tree, listIndex, sectionIndex, itemIndex, item.value, linkOnCheck, linkId, linkActionType);
			// 	break;
			case "itemLocation":
			case "itemAddress":
				setItemLocationChecked(tree, listIndex, sectionIndex, itemIndex, item.value, linkOnCheck, linkId, linkActionType);
				break;
			case "itemBarcodeScanner":
				setItemBarcodeChecked(tree, listIndex, sectionIndex, itemIndex);
				break;
			case "itemTextInput":
			case "itemTextInputMultiline":
				setItemTextInputChecked(tree, listIndex, sectionIndex, itemIndex, tree.get(["lastItemValue"]), linkOnCheck, linkId, linkActionType)
				// Signature for props
				//setItemTextInputChecked(tree, listIndex, sectionIndex, itemIndex, linkOnCheck, linkId, linkActionType)
				break;
			case "itemImagePicker":
				// TODO: Centralize this
				tree.set(["activity", "children", listIndex, "children", sectionIndex, "children", itemIndex, "checked"], true);

				setCompletionState(tree, listIndex, sectionIndex, itemIndex);

				if (linkOnCheck) {
					linkUrl(tree, linkActionType + ":" + linkId, { listIndex: listIndex, sectionIndex: sectionIndex, itemIndex: itemIndex });
				} else {
					setNextSelected(tree, listIndex, sectionIndex, itemIndex);
					//saveCurrentChecklistToStore(tree);
				}
				break;
			// case "itemSketchPad":
			// 	setItemSketchPadChecked(tree, listIndex, sectionIndex, itemIndex);
			// 	break;
			default: {
				console.error("Unknown item type", item);
			}
		}
	}
}

let mandatoryFirstOne = true;
export function refreshMandatory(tree) {
	// console.log(" In " + arguments.callee.name);
	// Recurse activity
	// First item get to where mandatory = true and checked = false mark enabled true
	// Mark all other items after that enabled = false
	let lists = tree.get(["activity", "children"]);
	console.log("Dealing with mandatory refresh", lists);
	mandatoryFirstOne = true;
	refreshMandatoryRecurse(lists, tree, 0, 0);
}

function refreshMandatoryRecurse(arr, tree, listIndex, sectionIndex) {
	// console.log(" In " + arguments.callee.name);
	for (let i = 0; i < arr.length; i++) {
		if (arr[i].type === "list") {
			tree.set(["activity", "children", i, "enabled"], true);
			listIndex = i;
		} else if (arr[i].type === "section") {
			tree.set(["activity", "children", listIndex, "children", i, "enabled"], true);
			sectionIndex = i;
		} else if (arr[i].type.startsWith("item")) {
			console.log("Look at items?", listIndex, tree.get(["activity", "selectedListIndex"]));
			if (listIndex === tree.get(["activity", "selectedListIndex"])) {
				const path = ["activity", "children", listIndex, "children", sectionIndex, "children", i, "enabled"];
				if (arr[i].mandatory && !arr[i].checked) {
					console.log("Unchecked mandatory found", path);
					if (mandatoryFirstOne) {
						mandatoryFirstOne = false;
						tree.set(path, true);
					} else {
						console.log("Disable", path);
						tree.set(path, false);
					}
				} else {
					tree.set(path, mandatoryFirstOne);
				}
			}
		}

		if (arr[i].hasOwnProperty("children")) {
			refreshMandatoryRecurse(arr[i].children, tree, listIndex, sectionIndex);
		}
	}
}

export function setItemCheckedForShowMode(tree, listIndex, sectionIndex, itemIndex, identityId) {
	setSelectedItem(tree, listIndex, sectionIndex, itemIndex, false);
	tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, itemIndex, "checked"), true);
	historyActions.checkItem(tree, listIndex + "," + sectionIndex + "," + itemIndex, identityId, tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, itemIndex)));
	setCompletionState(tree, listIndex, sectionIndex, itemIndex);
	ambifi.persistenceManager.saveResponse(tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, itemIndex)));

	//TODO: save on each swipe?
	//saveCurrentActivityToStore(tree);
}

export function setItemTextInputChecked(tree, listIndex, sectionIndex, itemIndex, value, identityId, linkOnCheck, linkId, linkActionType) {
	setSelectedItem(tree, listIndex, sectionIndex, itemIndex, false);
	// TODO: not great...because using state needed a way to also have current state at a higher level
	let lastItemValue = tree.get(["lastItemValue"]);

	if (value === "" && lastItemValue !== "") {
		value = lastItemValue;
	}

	if (!_.isString(value)) {
		value = "" + value;
	}

	//TODO: add resolve vars
	//value = Utils.resolveVars(value);

	let item = tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, itemIndex));
	setValueIfHasIdOrchestratedSync(item, value).then(() => {
		if (item.hasOwnProperty("valueTrigger") && item.valueTrigger !== "") {
			// Inject global procedure functions
			let strfun = tree.get(PlayerPaths.ACTIVITY_PROPERTY("functions"));
			let strEval = item.valueTrigger;
			if (!_.isEmpty(strfun)) {
				strEval = strfun + "\n" + strEval;
			}

			let AmbiFi = RuntimeApi;// eslint-disable-line
			var af = RuntimeApi; // eslint-disable-line
			var afState = state; // eslint-disable-line
			var afUtils = Utils; // eslint-disable-line
			var afAlert = showAlert; // eslint-disable-line
			eval(strEval);// eslint-disable-line
		}

		handleChangeProperty(tree, listIndex, sectionIndex, itemIndex, "checked", true);
		handleChangeProperty(tree, listIndex, sectionIndex, itemIndex, "value", value);
		setCompletionState(tree, listIndex, sectionIndex, itemIndex);
		refreshMandatory(tree);

		ambifi.persistenceManager.saveResponse(tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, itemIndex)));

		if (linkOnCheck) {
			linkUrl(tree, linkActionType + ":" + linkId, { listIndex: listIndex, sectionIndex: sectionIndex, itemIndex: itemIndex }, true);
		} else {
			setNextSelected(tree, listIndex, sectionIndex, itemIndex);
		}

		historyActions.setTextInput(tree, getActivityItemHistoryPath(listIndex, sectionIndex, itemIndex), value, identityId, item);

		tree.set(["lastItemValue"], "");
	}).catch(err => {
		console.error("", err);
	});
}

export function setItemYesNoChecked(tree, listIndex, sectionIndex, itemIndex, value, identityId, linkOnSelect, linkActionType, linkYesId, linkNoId, linkNaId) {
	setSelectedItem(tree, listIndex, sectionIndex, itemIndex, false);
	handleChangeProperty(tree, listIndex, sectionIndex, itemIndex, "checked", true);
	handleChangeProperty(tree, listIndex, sectionIndex, itemIndex, "value", value);
	tree.commit();
	let item = tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, itemIndex));

	setValueIfHasIdOrchestratedSync(item, value).then(() => {
		if (item.hasOwnProperty("valueTrigger") && item.valueTrigger !== "") {
			// Inject global procedure functions
			var strfun = tree.get(["activity", "functions"]);
			console.log("Item state:", tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, itemIndex)));
			var af = RuntimeApi;//eslint-disable-line
			var afState = tree;//eslint-disable-line
			var afUtils = Utils;//eslint-disable-line
			var afAlert = showAlert;//eslint-disable-line
			let stmt = item.valueTrigger;
			if (strfun !== "") {
				stmt = strfun + "\n" + stmt;
			}
			eval(stmt);//eslint-disable-line
		}
		ambifi.persistenceManager.saveResponse(tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, itemIndex)));
		historyActions.setYesNo(tree, getActivityItemHistoryPath(listIndex, sectionIndex, itemIndex), value, identityId, item);

		setCompletionState(tree, listIndex, sectionIndex);
		refreshMandatory(tree);

		let linkId = linkNaId;
		if (value === "yes") {
			linkId = linkYesId;
		} else if (value === "no") {
			linkId = linkNoId;
		}

		//setSelectedItem(tree, listIndex, sectionIndex, itemIndex, false);
		if (linkOnSelect) {
			linkUrl(tree, linkActionType + ":" + linkId, { listIndex: listIndex, sectionIndex: sectionIndex, itemIndex: itemIndex });
		} else {
			setNextSelected(tree, listIndex, sectionIndex, itemIndex);
		}
	}).catch(err => {
		console.error("", err);
	});
}

export function setItemPickerChecked(tree, listIndex, sectionIndex, itemIndex, value, identityId, linkOnSelect, linkId = "", linkActionType) {
	setSelectedItem(tree, listIndex, sectionIndex, itemIndex, false);
	handleChangeProperty(tree, listIndex, sectionIndex, itemIndex, "checked", true);
	handleChangeProperty(tree, listIndex, sectionIndex, itemIndex, "value", value);
	ambifi.persistenceManager.saveResponse(tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, itemIndex)));

	let item = tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, itemIndex));

	if (linkId === "") {
		linkId = value;
	}

	//console.log("Link on select " + linkOnSelect + " linkId: " + linkId + " linkActinType: " + linkActionType);
	setValueIfHasIdOrchestratedSync(item, value).then(() => {
		if (item.hasOwnProperty("valueTrigger") && item.valueTrigger !== "") {
			// Inject global procedure functions
			let strfun = tree.get(PlayerPaths.ACTIVITY_PROPERTY("functions"));
			let strEval = item.valueTrigger;
			if (!_.isEmpty(strfun)) {
				strEval = strfun + "\n" + strEval;
			}

			let AmbiFi = RuntimeApi;// eslint-disable-line
			var af = RuntimeApi; // eslint-disable-line
			var afState = state; // eslint-disable-line
			var afUtils = Utils; // eslint-disable-line
			var afAlert = showAlert; // eslint-disable-line
			eval(strEval);// eslint-disable-line
		}

		historyActions.setPicker(tree, getActivityItemHistoryPath(listIndex, sectionIndex, itemIndex), value, identityId, item);

		setCompletionState(tree, listIndex, sectionIndex);
		refreshMandatory(tree);

		//setSelectedItem(tree, listIndex, sectionIndex, itemIndex, false);
		if (linkOnSelect) {
			linkUrl(tree, linkActionType + ":" + linkId, { listIndex: listIndex, sectionIndex: sectionIndex, itemIndex: itemIndex });
		} else {
			setNextSelected(tree, listIndex, sectionIndex, itemIndex);
			//saveCurrentActivityToStore(tree); 
		}
	}).catch(err => {
		console.error("", err);
	});
}

export function setItemRankingChecked(tree, listIndex, sectionIndex, itemIndex, value, identityId, linkOnSelect, linkId = "", linkActionType) {
	setSelectedItem(tree, listIndex, sectionIndex, itemIndex, false);
	handleChangeProperty(tree, listIndex, sectionIndex, itemIndex, "checked", true);
	handleChangeProperty(tree, listIndex, sectionIndex, itemIndex, "value", value);
	ambifi.persistenceManager.saveResponse(tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, itemIndex)));

	let item = tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, itemIndex));

	if (linkId === "") {
		linkId = value;
	}

	//console.log("Link on select " + linkOnSelect + " linkId: " + linkId + " linkActinType: " + linkActionType);
	setValueIfHasIdOrchestratedSync(item, value).then(() => {
		if (item.hasOwnProperty("valueTrigger") && item.valueTrigger !== "") {
			// Inject global procedure functions
			let strfun = tree.get(PlayerPaths.ACTIVITY_PROPERTY("functions"));
			let strEval = item.valueTrigger;
			if (!_.isEmpty(strfun)) {
				strEval = strfun + "\n" + strEval;
			}

			let AmbiFi = RuntimeApi;// eslint-disable-line
			var af = RuntimeApi; // eslint-disable-line
			var afState = state; // eslint-disable-line
			var afUtils = Utils; // eslint-disable-line
			var afAlert = showAlert; // eslint-disable-line
			eval(strEval);// eslint-disable-line
		}

		historyActions.setPicker(tree, getActivityItemHistoryPath(listIndex, sectionIndex, itemIndex), value, identityId, item);

		setCompletionState(tree, listIndex, sectionIndex);
		refreshMandatory(tree);

		//setSelectedItem(tree, listIndex, sectionIndex, itemIndex, false);
		if (linkOnSelect) {
			linkUrl(tree, linkActionType + ":" + linkId, { listIndex: listIndex, sectionIndex: sectionIndex, itemIndex: itemIndex });
		} else {
			setNextSelected(tree, listIndex, sectionIndex, itemIndex);
			//saveCurrentActivityToStore(tree); 
		}
	}).catch(err => {
		console.error("", err);
	});
}

export function setItemDateChecked(tree, listIndex, sectionIndex, itemIndex, value, mode, identityId, linkOnCheck, linkId, linkActionType) {
	setSelectedItem(tree, listIndex, sectionIndex, itemIndex, false);

	let valueUtc = "";
	let valueLocale = "";
	let tempDateTime = "";

	let item = tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, itemIndex));

	mode = mode.toLowerCase();

	if (mode === "itemdate") {

		if (value !== null && value !== "") {
			if (value === "today") {
				tempDateTime = mcMoment(item);
			} else if (value !== "") {
				tempDateTime = mcMoment(item, value + "T12:00:00");
			}

			valueUtc = tempDateTime.toISOString("YYYY-MM-DD");
			valueLocale = tempDateTime.format("YYYY-MM-DD");
		}
	} else if (mode === "itemtime") {

		if (value !== null && value !== "") {
			if (value === "today") {
				tempDateTime = mcMoment(item);
			} else if (value !== "") {
				tempDateTime = mcMoment(item, mcMoment(item).format("YYYY-MM-DD") + "T" + value);
			}

			valueUtc = tempDateTime.format("HH:mm");
			valueLocale = tempDateTime.format("HH:mm");
		}
	} else if (mode === "itemdatetime") {

		if (value !== null && value !== "") {
			if (value === "today") {
				tempDateTime = mcMoment(item);
			} else if (value !== "") {
				tempDateTime = mcMoment(item, value);
			}

			valueUtc = tempDateTime.toISOString();
			valueLocale = tempDateTime.format();
		}
	}

	handleChangeProperty(tree, listIndex, sectionIndex, itemIndex, "checked", true);
	handleChangeProperty(tree, listIndex, sectionIndex, itemIndex, "value", valueLocale);
	ambifi.persistenceManager.saveResponse(tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, itemIndex)));

	setValueIfHasIdOrchestratedSync(item, valueLocale).then(() => {
		if (item.hasOwnProperty("valueTrigger") && item.valueTrigger !== "") {
			// Inject global procedure functions
			let strfun = tree.get(PlayerPaths.ACTIVITY_PROPERTY("functions"));
			let strEval = item.valueTrigger;
			if (!_.isEmpty(strfun)) {
				strEval = strfun + "\n" + strEval;
			}

			let AmbiFi = RuntimeApi;// eslint-disable-line
			var af = RuntimeApi; // eslint-disable-line
			var afState = state; // eslint-disable-line
			var afUtils = Utils; // eslint-disable-line
			var afAlert = showAlert; // eslint-disable-line
			eval(strEval);// eslint-disable-line
		}

		console.log("In setItemDateChecked: " + listIndex + "; " + sectionIndex + "; " + itemIndex);
		handleChangeProperty(tree, listIndex, sectionIndex, itemIndex, "checked", true);

		historyActions.setDate(tree, getActivityItemHistoryPath(listIndex, sectionIndex, itemIndex), valueLocale, valueUtc, identityId, item);

		setCompletionState(tree, listIndex, sectionIndex);
		refreshMandatory(tree);

		if (linkOnCheck) {
			linkUrl(tree, linkActionType + ":" + linkId, { listIndex: listIndex, sectionIndex: sectionIndex, itemIndex: itemIndex }, true);
		} else {
			setNextSelected(tree, listIndex, sectionIndex, itemIndex);
		}
	}).catch(err => {
		console.error("", err);
	});
}

export function inlineLinkUrl(link, listIndex, sectionIndex, itemIndex) {
	//inline link will select item	
	setSelectedItem(state, listIndex, sectionIndex, itemIndex, false);
	linkUrl(state, link, { listIndex, sectionIndex, itemIndex });
}

export function setItemLocationChecked(tree, listIndex, sectionIndex, itemIndex, value, identityId, linkOnCheck, linkId, linkActionType) {
	setSelectedItem(tree, listIndex, sectionIndex, itemIndex, false);

	let item = tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, itemIndex));

	setValueIfHasIdOrchestratedSync(item, value).then(() => {

		if (item.hasOwnProperty("valueTrigger") && item.valueTrigger !== "") {
			// Inject global procedure functions
			let strfun = tree.get(PlayerPaths.ACTIVITY_PROPERTY("functions"));
			let strEval = item.valueTrigger;
			if (!_.isEmpty(strfun)) {
				strEval = strfun + "\n" + strEval;
			}

			let AmbiFi = RuntimeApi;// eslint-disable-line
			var af = RuntimeApi; // eslint-disable-line
			var afState = state; // eslint-disable-line
			var afUtils = Utils; // eslint-disable-line
			var afAlert = showAlert; // eslint-disable-line
			eval(strEval);// eslint-disable-line
		}

		handleChangeProperty(tree, listIndex, sectionIndex, itemIndex, "checked", true);
		handleChangeProperty(tree, listIndex, sectionIndex, itemIndex, "value", value);
		setCompletionState(tree, listIndex, sectionIndex);
		refreshMandatory(tree);
		ambifi.persistenceManager.saveResponse(tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, itemIndex)));

		historyActions.setLocation(tree, getActivityItemHistoryPath(listIndex, sectionIndex, itemIndex), value, identityId, item);

		if (linkOnCheck) {
			linkUrl(tree, linkActionType + ":" + linkId, { listIndex: listIndex, sectionIndex: sectionIndex, itemIndex: itemIndex }, true);
		} else {
			setNextSelected(tree, listIndex, sectionIndex, itemIndex);
		}
	}).catch(err => {
		console.error("", err);
	});
}

export function setItemChoiceSingleChecked(tree, listIndex, sectionIndex, itemIndex, value, choiceItem, identityId, linkOnCheck, linkId = "", linkActionType) {
	setSelectedItem(tree, listIndex, sectionIndex, itemIndex, false);

	handleChangeProperty(tree, listIndex, sectionIndex, itemIndex, "checked", true);
	handleChangeProperty(tree, listIndex, sectionIndex, itemIndex, "value", value);
	ambifi.persistenceManager.saveResponse(tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, itemIndex)));

	let item = tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, itemIndex));

	setValueIfHasIdOrchestratedSync(item, value).then(() => {
		if (item.hasOwnProperty("valueTrigger") && item.valueTrigger !== "") {
			// Inject global procedure functions
			let strfun = tree.get(PlayerPaths.ACTIVITY_PROPERTY("functions"));
			let strEval = item.valueTrigger;
			if (!_.isEmpty(strfun)) {
				strEval = strfun + "\n" + strEval;
			}

			let AmbiFi = RuntimeApi;// eslint-disable-line
			var af = RuntimeApi; // eslint-disable-line
			var afState = state; // eslint-disable-line
			var afUtils = Utils; // eslint-disable-line
			var afAlert = showAlert; // eslint-disable-line
			eval(strEval);// eslint-disable-line
		}

		// Need History for Choice Multi
		//History.setPicker(tree, listIndex + "," + sectionIndex + "," + itemIndex, value);
		setCompletionState(tree, listIndex, sectionIndex);
		refreshMandatory(tree);

		if (!_.isUndefined(choiceItem) && choiceItem.hasOwnProperty("linking")) {
			linkOnCheck = true;
			linkActionType = choiceItem.linking.split(":")[0];
			linkId = choiceItem.linking.split(":")[1];
		} else if (linkId === "") {
			linkId = value;
		}


		if (linkOnCheck) {
			linkUrl(tree, linkActionType + ":" + linkId, { listIndex: listIndex, sectionIndex: sectionIndex, itemIndex: itemIndex }, true);
		} else {
			setNextSelected(tree, listIndex, sectionIndex, itemIndex);
			//saveCurrentActivityToStore(tree); 
		}

	}).catch(err => {
		console.error("", err);
	});

}

export function setItemChoiceMultiChecked(tree, listIndex, sectionIndex, itemIndex, value, identityId, linkOnCheck, linkId, linkActionType) {
	setSelectedItem(tree, listIndex, sectionIndex, itemIndex, false);

	handleChangeProperty(tree, listIndex, sectionIndex, itemIndex, "checked", true);
	handleChangeProperty(tree, listIndex, sectionIndex, itemIndex, "value", value);
	setCompletionState(tree, listIndex, sectionIndex);
	refreshMandatory(tree);



	let item = tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, itemIndex));

	ambifi.persistenceManager.saveResponse(tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, itemIndex)));


	setValueIfHasIdOrchestratedSync(item, value).then(() => {
		if (item.hasOwnProperty("valueTrigger") && item.valueTrigger !== "") {
			// Inject global procedure functions
			let strfun = tree.get(PlayerPaths.ACTIVITY_PROPERTY("functions"));
			let strEval = item.valueTrigger;
			if (!_.isEmpty(strfun)) {
				strEval = strfun + "\n" + strEval;
			}

			let AmbiFi = RuntimeApi;// eslint-disable-line
			var af = RuntimeApi; // eslint-disable-line
			var afState = state; // eslint-disable-line
			var afUtils = Utils; // eslint-disable-line
			var afAlert = showAlert; // eslint-disable-line
			eval(strEval);// eslint-disable-line
		}
		// Need History for Choice Multi
		//History.setPicker(tree, listIndex + "," + sectionIndex + "," + itemIndex, value);

		setCompletionState(tree, listIndex, sectionIndex, itemIndex);

		if (linkOnCheck) {
			linkUrl(tree, linkActionType + ":" + linkId, { listIndex: listIndex, sectionIndex: sectionIndex, itemIndex: itemIndex }, true);
		} else {
			setNextSelected(tree, listIndex, sectionIndex, itemIndex);
			//saveCurrentActivityToStore(tree); 
		}

	}).catch(err => {
		console.error("", err);
	});
}

export function setItemImagePickerAddMedia(tree, listIndex, sectionIndex, itemIndex, value, valueUrls, uploaded, identityId) {
	setSelectedItem(tree, listIndex, sectionIndex, itemIndex, false);

	const lastImageUrl = valueUrls ? valueUrls[valueUrls.length - 1] : null;

	let item = tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, itemIndex));

	if (item.hasOwnProperty("valueTrigger") && item.valueTrigger !== "") {
		// Inject global procedure functions
		let strfun = tree.get(PlayerPaths.ACTIVITY_PROPERTY("functions"));
		let strEval = item.valueTrigger;
		if (!_.isEmpty(strfun)) {
			strEval = strfun + "\n" + strEval;
		}

		let AmbiFi = RuntimeApi;// eslint-disable-line
		var af = RuntimeApi; // eslint-disable-line
		var afState = state; // eslint-disable-line
		var afUtils = Utils; // eslint-disable-line
		var afAlert = showAlert; // eslint-disable-line
		eval(strEval);// eslint-disable-line
	}

	handleChangeProperty(tree, listIndex, sectionIndex, itemIndex, "checked", true);
	handleChangeProperty(tree, listIndex, sectionIndex, itemIndex, "value", value);
	handleChangeProperty(tree, listIndex, sectionIndex, itemIndex, "valueUrls", valueUrls);
	setCompletionState(tree, listIndex, sectionIndex);
	refreshMandatory(tree);
	ambifi.persistenceManager.saveResponse(tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, itemIndex)));
	setNextSelected(tree, listIndex, sectionIndex, itemIndex);

	historyActions.setImagePicker(tree, getActivityItemHistoryPath(listIndex, sectionIndex, itemIndex), lastImageUrl, identityId, item);
}

export function addMediaAttachmentHistoryEntry(tree, listIndex, sectionIndex, itemIndex, value, valueUrls, uploaded, identityId) {
	const lastImageUrl = valueUrls ? valueUrls[valueUrls.length - 1] : null;
	historyActions.setMediaAttachment(tree, getActivityItemHistoryPath(listIndex, sectionIndex, itemIndex), lastImageUrl, identityId, tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, itemIndex)));
}

export function setItemBarcodeChecked(tree, listIndex, sectionIndex, itemIndex, value, identityId) {
	setSelectedItem(tree, listIndex, sectionIndex, itemIndex, false);

	let item = tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, itemIndex));

	handleChangeProperty(tree, listIndex, sectionIndex, itemIndex, ["barcode", "data"], value);
	ambifi.persistenceManager.saveResponse(tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, itemIndex)));

	setValueIfHasIdOrchestratedSync(item, item.barcode && item.barcode.data ? item.barcode.data : "").then(() => {
		if (item.hasOwnProperty("valueTrigger") && item.valueTrigger !== "") {
			// Inject global procedure functions
			let strfun = tree.get(PlayerPaths.ACTIVITY_PROPERTY("functions"));
			let strEval = item.valueTrigger;
			if (!_.isEmpty(strfun)) {
				strEval = strfun + "\n" + strEval;
			}

			let AmbiFi = RuntimeApi;// eslint-disable-line
			var af = RuntimeApi; // eslint-disable-line
			var afState = state; // eslint-disable-line
			var afUtils = Utils; // eslint-disable-line
			var afAlert = showAlert; // eslint-disable-line
			eval(strEval);// eslint-disable-line
		}

		console.log("In setItemBarcodeChecked: " + listIndex + "; " + sectionIndex + "; " + itemIndex);
		handleChangeProperty(tree, listIndex, sectionIndex, itemIndex, "checked", true);

		setCompletionState(tree, listIndex, sectionIndex, itemIndex);
		refreshMandatory(tree);
		setNextSelected(tree, listIndex, sectionIndex, itemIndex);
	}).catch(err => {
		console.error("", err);
	});


	historyActions.setBarcode(tree, getActivityItemHistoryPath(listIndex, sectionIndex, itemIndex), value, identityId, item);
}

export function loadActivities(baseInventory = null) {

	// return inventoryActions.assembleActivitiesForWeb(baseInventory).then((result) => {		
	// 	state.set(PlayerPaths.ACTIVITIES, result);

	// 	return algolia.searchUserActivities().then((content) => {
	// 		let sessions = {};

	// 		_.each(content.hits, (hit) => {

	// 			if (_.isUndefined(sessions[hit.id])) {
	// 				sessions[hit.id] = [];
	// 			}
	// 			sessions[hit.id].push(hit);
	// 		});


	// 		_.each(sessions, (activitySessions, id) => {
	// 			sessions[id] = _.orderBy(activitySessions, ["updatedDateTimeDate"], ["desc"]);
	// 		});

	// 		state.set(PlayerPaths.SESSIONS, sessions);
	// 		state.set(PlayerPaths.ACTIVITIES_LOADED, true);
	// 		state.set(PlayerPaths.RELOAD_ACTIVITIES, false);

	// 	}).catch((err) => {
	// 		throw err;
	// 	});

	// }).catch((err) => {
	// 	console.error(err);
	// });

}

/**
 *  Reload activities due to add/remove
 */
export function reloadActivities(tree) {
	// tree.set(PlayerPaths.SHOW_SPINNER, true);	

	// return new Promise((resolve, reject) => {
	// 	inventoryActions.initializeInventory(true).then(async (inventory) => {
	// 		loadActivities(inventory).then(() => {
	// 			tree.set(PlayerPaths.RELOAD_ACTIVITIES, false);	
	// 			tree.set(PlayerPaths.SHOW_SPINNER, false);
	// 			resolve();
	// 		}).catch((err) => {
	// 			console.error("Load Activities", err, err.stack);
	// 			showError("Load Activities", "Unable to load activities, this might be due to network connectivity issues.");				
	// 			tree.set(PlayerPaths.SHOW_SPINNER, false);
	// 			reject(err);
	// 		});
	// 	});
	// });	
}

export function startNewActivity(tree, activity, initialItemId) {
	let activities = tree.get(PlayerPaths.ACTIVITIES);
	let _activity = Utils.normalizeActivity(_.cloneDeep(_.find(activities, { id: activity.id })));
	_activity.showModeKey = `sm-${new Date().getTime()}`;
	initializeActivity(tree, _activity);
	setSelectedItem(tree, 0, 0, 0, true, false);
	ensureExpanded(tree, 0, 0);
}

export function resumeActivity(tree, activityId, activityInstanceId, initialItemId, url = null) {

	// tree.set(PlayerPaths.SHOW_SPINNER, true);
	tree.set(PlayerPaths.SELECTED_ACTIVITY_ID, activityId);
	tree.set(PlayerPaths.SELECTED_ACTIVITY_INSTANCE_ID, activityInstanceId);

	let activities = tree.get(PlayerPaths.ACTIVITIES);

	let activity = _.find(activities, { id: activityId });

	initializeActivity(tree, activity, initialItemId);

	// if (url === null) {
	// 	//look up URL from sessions
	// 	let sessions = tree.get(PlayerPaths.SESSIONS_BY_ACTIVITY_ID(activityId));
	// 	if (!_.isUndefined(sessions)) {
	// 		let index = _.findIndex(sessions, { id: activityId, instanceId: activityInstanceId });
	// 		if (index !== -1) {
	// 			url = sessions[index].url;
	// 		}
	// 	}		
	// } 

	// if (url !== null) {

	// 	awsS3.loadActivityInstanceFromS3(env.s3.contentBucket, url).then((result) => {
	// 		initializeActivity(tree, result, initialItemId);

	// 		tree.set(PlayerPaths.SHOW_SESSIONS_MODAL, false);
	// 		tree.set(PlayerPaths.SHOW_SPINNER, false);

	// 		const path = "/player/" + activityId + "/" + activityInstanceId;
	// 		browserHistory.push(path);

	// 	}).catch((err) => {
	// 		tree.set(PlayerPaths.SHOW_SPINNER, false);
	// 		showError("Unable to resume activity", err);
	// 	});
	// } else {
	// 	//no activity session found
	// 	tree.set(PlayerPaths.SHOW_SPINNER, false);
	// 	navActions.navigateTo("home");
	// }
}

export async function loadLinkedActivity(tree, activityId, initialItemId, newSession = false) {

	let activity = tree.get(PlayerPaths.ACTIVITY);
	let activityMetaData = getActivityMetaData(activity.id);

	tree.set(PlayerPaths.SHOW_SPINNER, true);

	if (activityMetaData.trackData !== false) {
		ambifi.persistenceManager.save().then(() => {
			return ambifi.persistenceManager.loadActivity(activityId, initialItemId, true).then((activity) => {
				resolveActivityFonts(activity);
				tree.set(PlayerPaths.SHOW_SPINNER, false);
				historyActions.openActivity(tree, tree.get(["user"]).identityId, activity);
			});
		}).catch((err) => {
			showError("Error", `Unable to load linked activity: ${activityId}.`, err);
		});
	} else {
		ambifi.persistenceManager.loadActivity(activityId, initialItemId, true).then((activity) => {
			resolveActivityFonts(activity);
			tree.set(PlayerPaths.SHOW_SPINNER, false);
			historyActions.openActivity(tree, tree.get(["user"]).identityId, activity);
		});
	}

	// return saveActivityFromPlayer(tree).then(() => {
	// 	let sessions = tree.get(PlayerPaths.SESSIONS_BY_ACTIVITY_ID(activityId));

	// 	let promise;

	// 	if (!_.isUndefined(sessions) && sessions.length > 0 && newSession === false) {
	// 		promise = resumeActivity(tree, activity.id, sessions[0].instanceId, initialItemId);
	// 	} else {
	// 		promise = startNewActivity(tree, activity, initialItemId);
	// 	}
	// 	return promise;
	// });
}

export function goBackFromLinkedActivity(tree, activity, initialItemId) {
	window.activityTheme = activity.theme;
	tree.set(PlayerPaths.ACTIVITY, activity);
	resolveActivityFonts(activity);

	initializeIdsAndVariableState(tree);
	initializeOrchestrator();

	//console.log("CURRENT ACTIVITY: ", tree.get(PlayerPaths.ACTIVITY));
	//console.log(JSON.stringify(tree.get(PlayerPaths.ACTIVITY), null, 4));



	Utils.populateIds(tree);
	Utils.buildGroups(tree);

	setDefaultValues(tree, 0, 0);
	refreshMandatory(tree);
	historyActions.openActivity(tree, tree.get(["user"]).identityId, activity);
}

export function initializeActivity(tree, activity, initialItem = null, skipToNextItem) {
	if (activity !== null) {
		if (activity.children &&
			activity.children.length > 0 &&
			activity.children[0].children &&
			activity.children[0].children.length > 0 &&
			activity.children[0].children[0].children &&
			activity.children[0].children[0].children.length > 0) {


			let clonedActivity = _.cloneDeep(activity);
			if (_.isUndefined(clonedActivity.instanceId)) {
				clonedActivity.instanceId = generateUUID();
			}

			tree.set(PlayerPaths.ACTIVITY, clonedActivity);

			let selectedListIndex = tree.get(PlayerPaths.ACTIVITY_SELECTED_LIST_INDEX);
			let selectedSectionIndex = tree.get(PlayerPaths.ACTIVITY_SELECTED_SECTION_INDEX);
			let selectedItemIndex = tree.get(PlayerPaths.ACTIVITY_SELECTED_ITEM_INDEX);

			if (!_.isNumber(selectedListIndex)) {
				tree.set(PlayerPaths.ACTIVITY_SELECTED_LIST_INDEX, 0);
			}

			if (!_.isNumber(selectedSectionIndex)) {
				tree.set(PlayerPaths.ACTIVITY_SELECTED_SECTION_INDEX, 0);
			}

			if (!_.isNumber(selectedItemIndex)) {
				tree.set(PlayerPaths.ACTIVITY_SELECTED_ITEM_INDEX, 0);
			}

			tree.set(PlayerPaths.SELECTED_ACTIVITY_ID, activity.id);


			const _activity = transformToActivityPlayer(tree.get(PlayerPaths.ACTIVITY));
			const nightMode = tree.get(["nightMode"]);
			let theme = themes[(nightMode) ? "nightMode" : "default"];

			if (_activity.theme && !_.isEmpty(_activity.theme)) {
				theme = deepmerge.all([theme, _activity.theme]);
			}

			_activity.theme = theme;
			window.activityTheme = theme;

			Utils.resolveAllActivityStyles(_activity, theme, nightMode);

			tree.set(PlayerPaths.ACTIVITY, _activity);

			/*
					if (activity.hasOwnProperty("global")) {
						global.ambifi = activity.global;
					}
					*/
			initializeIdsAndVariableState(tree);
			initializeOrchestrator();

			//console.log("CURRENT ACTIVITY: ", tree.get(PlayerPaths.ACTIVITY));
			//console.log(JSON.stringify(tree.get(PlayerPaths.ACTIVITY), null, 4));



			Utils.populateIds(tree);
			Utils.buildGroups(tree);

			setDefaultValues(tree, 0, 0);
			refreshMandatory(tree);




			// If don't have any history, create it
			if (!tree.get(PlayerPaths.ACTIVITY_HISTORY)) {
				tree.set(PlayerPaths.ACTIVITY_HISTORY, []);
			}

			if (!tree.get(PlayerPaths.ACTIVITY_HISTORY_GEOLOCATION)) {
				tree.set(PlayerPaths.ACTIVITY_HISTORY_GEOLOCATION, []);
			}

			if (!tree.get(PlayerPaths.ACTIVITY_LOGBOOK)) {
				tree.set(PlayerPaths.ACTIVITY_LOGBOOK_TIME_OUT, "------------");
				tree.set(PlayerPaths.ACTIVITY_LOGBOOK_TIME_OUT, "------------");
			}

			// Set instance id to latest instance
			//tree.set(["activity", "instanceId"], instanceId);

			//historyActions.openActivity(tree, tree.get(["user"]).identityId);

			//let activity = tree.get(PlayerPaths.ACTIVITY);
			//let firstLevel = tree.get(["activity", "firstLevel"]);


			// If a deep link is provided, go there
			try {
				if (initialItem !== null) {
					let newItem = {
						listIndex: 0,
						sectionIndex: 0,
						itemIndex: 0
					};

					console.log("INITIAL ITEM", initialItem);

					if (initialItem.startsWith("#")) {
						newItem = tree.get(["idMap", initialItem.substring(1)]);
					} else {
						let itemParts = initialItem.split(",");

						if (itemParts.length === 3) {
							newItem.listIndex = Number(itemParts[0]);
							newItem.sectionIndex = Number(itemParts[1]);
							newItem.itemIndex = Number(itemParts[2]);
						} else if (itemParts.length === 2) {
							newItem.listIndex = Number(itemParts[0]);
							newItem.sectionIndex = Number(itemParts[1]);
						} else if (itemParts.length === 1) {
							newItem.listIndex = Number(itemParts[0]);
						}
					}
					// Seems like hack
					//clearActivity(tree);
					gotoItem(tree, newItem.listIndex, newItem.sectionIndex, newItem.itemIndex);
				} else {
					// Seems like hack
					//clearActivity(tree);
					if (!skipToNextItem) {
						setTimeout(() => {
							showSelectedItem(tree);
						});
					} else {
						gotoNextItem(tree);
					}
				}
			} catch (e) {
				// Seems like hack
				gotoItem(tree, 0, 0, 0);
				//if (hideShowModeAfterSet) {
				//		tree.set(["appState", "modalShowModeVisible"], false);
				//	}						
			}


			if (tree.get(PlayerPaths.ACTIVITY_START_IN_SHOW_MODE) && tree.get(["appCapabilities", "showMode"])) {
				//do something if show mode enabled
			} else {
				//do something else if show mode is not enabled
			}
		} else {
			throw new Error(ACTIVITY_NO_CONTENT_ERROR_MESSAGE);
		}
	}
}


export function setDefaultValues(tree, listIndex, sectionIndex, force = false) {

	let lists = tree.get(PlayerPaths.ACTIVITY_LISTS);

	setDefaultValuesRecurse(lists, tree, listIndex, sectionIndex, force);
}

export function setDefaultValuesForList(tree, listIndex, sectionIndex, force = false) {

	let sections = tree.get(PlayerPaths.ACTIVITY_SECTIONS(listIndex));

	setDefaultValuesRecurse(sections, tree, listIndex, sectionIndex, force);
}

export function setDefaultValuesForSection(tree, listIndex, sectionIndex, force = false) {

	let items = tree.get(PlayerPaths.ACTIVITY_ITEMS(listIndex, sectionIndex));

	setDefaultValuesRecurse(items, tree, listIndex, sectionIndex, force);
}


function setDefaultValuesRecurse(arr, tree, listIndex, sectionIndex, force) {

	for (let i = 0; i < arr.length; i++) {
		if (arr[i].type === "list") {
			listIndex = i;
		} else if (arr[i].type === "section") {
			sectionIndex = i;
		} else if (arr[i].type.startsWith("item")) {
			let item = arr[i];
			let value;
			switch (item.type) {
				case "item":
					break;
				case "itemDate":
					if (!item.hasOwnProperty("value") || force) {
						if (item.hasOwnProperty("dateTimeInitialDate") && item.dateTimeInitialDate.toLowerCase() === "today") {
							value = "today";
						} else {
							value = item.dateTimeInitialDate;
						}
						tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, i, "value"), value);
					}
					break;
				case "itemTime":
					if (!item.hasOwnProperty("value") || force) {
						if (item.hasOwnProperty("dateTimeInitialDate") && item.dateTimeInitialDate.toLowerCase() === "today") {
							value = "today";
						} else {
							value = item.dateTimeInitialDate;
						}
						tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, i, "value"), value);
					}
					break;
				case "itemDateTime":
					if (!item.hasOwnProperty("value") || force) {
						if (item.hasOwnProperty("dateTimeInitialDate") && item.dateTimeInitialDate.toLowerCase() === "today") {
							value = "today";
						} else {
							value = item.dateTimeInitialDate;
						}
						tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, i, "value"), value);
					}
					break;
				case "itemLocation":
					if (!item.hasOwnProperty("value") || force) {
						tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, i, "value"), { address: "(No location selected)", name: "No name selected" });
					}
					break;
				case "itemAddress":
					if (!item.hasOwnProperty("value") || force) {
						tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, i, "value"), { address: "(No location selected)", name: "No name selected" });
					}
					break;
				case "itemTextInput":
				case "itemTextInputMultiline":
					// Set default value
					if (!item.hasOwnProperty("value") || force) {
						if (item.hasOwnProperty("textInputDefaultValue") && item.textInputDefaultValue !== "") {
							tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, i, "value"), item.textInputDefaultValue);
						} else {
							tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, i, "value"), "");
						}
					}
					break;
				case "itemYesNo":
					if (!item.hasOwnProperty("value") || force) {
						let value = "";

						tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, i, "value"), value);
					}
					break;
				case "itemPicker":
					if (!item.hasOwnProperty("value") || force) {
						let value = "";
						if (item.hasOwnProperty("pickerItemDefaultValue") && item.pickerItemDefaultValue !== "") {
							value = item.pickerItemDefaultValue;
						}

						tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, i, "value"), value);
					}
					break;
				case "itemChoiceSingle":
					if (!item.hasOwnProperty("value") || force) {
						let value = "";

						tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, i, "value"), value);
					}
					break;
				case "itemChoiceMulti":
					if (!item.hasOwnProperty("value") || force) {
						let value = [];

						// for (var j = 0; j < item.choiceItems.length; j++) {
						// 	value.push(false);
						// }

						tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, i, "value"), value);
					}
					break;
				case "itemImagePicker":
					if (!item.hasOwnProperty("value") || force) {
						tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, i, "value"), null);
					}
					if (!item.hasOwnProperty("valueUrls") || force) {
						tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, i, "valueUrls"), null);
					}
					break;
				// case "itemBarcodeScanner":
				// 	if (!item.hasOwnProperty("barcode")) {
				// 		tree.set(["activity", "children", listIndex, "children", sectionIndex, "children", i, "barcode"], null);
				// 	}	
				// case "itemSketchPad":
				// 	if (!item.hasOwnProperty("sketchPadImage")) {
				// 		tree.set(["activity", "children", listIndex, "children", sectionIndex, "children", i, "sketchPadImage"], null);
				// 	}
				// 	if (!item.hasOwnProperty("sketchPadImagePaths")) {
				// 		tree.set(["activity", "children", listIndex, "children", sectionIndex, "children", i, "sketchPadImagePaths"], []);
				// 	}	
				default:
					break;
			}
		}


		if (arr[i].hasOwnProperty("children")) {
			setDefaultValuesRecurse(arr[i].children, tree, listIndex, sectionIndex, force);
		}
	}
}

export async function saveActivity(tree) {

	// let activity = transformFromActivityPlayer(tree.get(PlayerPaths.ACTIVITY));

	// if (activity.history.length > 0) {
	// 	tree.set(PlayerPaths.SHOW_SPINNER, true);

	// 	return mobileAppCommunicationActions.saveHistoryInstances([activity]).then(() => {
	// 		tree.set(PlayerPaths.SHOW_SPINNER, false);
	// 	}).catch((err) => {
	// 		tree.set(PlayerPaths.SHOW_SPINNER, false);
	// 		showError("Activity Save Failed", "An error occurred saving the activity: " + err);
	// 	});
	// } else {
	// 	return Promise.resolve();
	// }	
	let activity = tree.get(PlayerPaths.ACTIVITY);
	let activityMetaData = getActivityMetaData(activity.id);

	if (activityMetaData.trackData !== false) {
		state.set(PlayerPaths.SHOW_SPINNER, true);
		ambifi.persistenceManager.save().then(() => {
			state.set(PlayerPaths.SHOW_SPINNER, false);
		}).catch((err) => {
			state.set(PlayerPaths.SHOW_SPINNER, false);
			showError("Error", "Unable to save activity: " + err);
		})
	}
}

export function saveActivityAndExit() {
	//let before nav handle save
	// navActions.navigateTo("home");
	let activity = state.get(PlayerPaths.ACTIVITY);
	let activityMetaData = getActivityMetaData(activity.id);

	if (activityMetaData.trackData !== false) {
		state.set(PlayerPaths.SHOW_SPINNER, true);
		ambifi.persistenceManager.saveAndExit().then((exitEvent) => {
			state.set(PlayerPaths.SHOW_SPINNER, false);

			if (ambifi.playerCallbacks.onExit) {
				ambifi.playerCallbacks.onExit(exitEvent);
			}
		}).catch((err) => {
			state.set(PlayerPaths.SHOW_SPINNER, false);
			showError("Error", "Unable to save activity: " + err);
		})
	} else {
		if (ambifi.playerCallbacks.onExit) {
			ambifi.playerCallbacks.onExit({
				activity
			});
		}
	}
}


export function saveActivityAndExitShowMode(tree) {
	//let before nav handle save
	let navStack = tree.get(PlayerPaths.NAV_STACK);

	console.log("NAV STACK", navStack);

	if (navStack.length > 0) {
		let activity = tree.get(PlayerPaths.ACTIVITY);

		state.set(PlayerPaths.SHOW_SPINNER, true);

		let activityMetaData = getActivityMetaData(activity.id);
		const persistenceType = tree.get(["appState", "targetConfig", "type"]);
		const isNonDefaultPersistence = persistenceType && persistenceType.toLowerCase() !== "default";
		if (activityMetaData.trackData !== false && isNonDefaultPersistence) {
			ambifi.persistenceManager.save().then(() => {
				state.set(PlayerPaths.SHOW_SPINNER, false);
				goBackFromLink(tree);
			}).catch((err) => {
				state.set(PlayerPaths.SHOW_SPINNER, false);
				showError("Error", "Unable to save activity: " + err);
			});
		} else {
			state.set(PlayerPaths.SHOW_SPINNER, false);
			goBackFromLink(tree);
		}
	} else {
		// navActions.navigateTo("home");
		saveActivityAndExit();
	}
}

export function exit(tree) {
	let activity = state.get(PlayerPaths.ACTIVITY);
	if (ambifi.playerCallbacks.onExit) {
		ambifi.playerCallbacks.onExit({
			activity
		});
	}
}

export function showSessionsModal(tree, activityId) {

	tree.set(PlayerPaths.SELECTED_ACTIVITY_ID, activityId);

	sortSessions(tree, "updatedDateTimeDate");

	tree.set(PlayerPaths.SHOW_SESSIONS_MODAL, true);
}

export function closeSessionsModal(tree) {
	tree.set(PlayerPaths.SELECTED_ACTIVITY_ID, "");
	tree.set(PlayerPaths.SHOW_SESSIONS_MODAL, false);
}

export function getSelectedActivityId() {
	return state.get(PlayerPaths.SELECTED_ACTIVITY_ID);
}

export function sortSessions(tree, sortCriteria) {
	console.log("handle sort " + sortCriteria);

	let allActivitySessions = tree.get(PlayerPaths.SESSIONS);
	let selectedActivityId = tree.get(PlayerPaths.SELECTED_ACTIVITY_ID);

	if (!_.isUndefined(allActivitySessions[selectedActivityId])) {
		const now = moment();

		let sessions = allActivitySessions[selectedActivityId];
		let instanceDefinitions = sessions.map(function (instance, j) {
			const instanceDefiniton = _.cloneDeep(instance);
			instanceDefiniton.index = j;
			instanceDefiniton.today = false;
			const rawCreatedDate = instance.hasOwnProperty("createdDateTime") ? moment.utc(instance.createdDateTime * 1000).local() : null;
			let createdDateTime = null;
			if (rawCreatedDate) {
				createdDateTime = rawCreatedDate.local().format("MMMM Do YYYY, h: mm: ss a");
				instanceDefiniton.rawCreatedDate = rawCreatedDate;
				instanceDefiniton.createdDateTimeDate = rawCreatedDate.toDate();
			}
			instanceDefiniton.createdDateTimeFormatted = createdDateTime;
			const rawUpdatedDate = instance.hasOwnProperty("lastUpdatedDateTime") ? moment.utc(instance.lastUpdatedDateTime * 1000).local() : null;
			let updatedDateTime = null;
			if (rawUpdatedDate) {
				updatedDateTime = rawUpdatedDate.local().format("MMMM Do YYYY, h: mm: ss a");
				instanceDefiniton.today = now.isSame(rawUpdatedDate, "day");
				instanceDefiniton.updatedDateTimeDate = rawUpdatedDate.toDate();
			}
			instanceDefiniton.updatedDateTimeFormatted = updatedDateTime;
			return instanceDefiniton;
		});

		let sortedInstanceDefinitions = [];
		instanceDefinitions.forEach(instanceDefinition => {
			if (instanceDefinition.hasOwnProperty(sortCriteria) && instanceDefinition[sortCriteria] !== null) {
				sortedInstanceDefinitions.push(instanceDefinition);
			}
		});

		sortedInstanceDefinitions = _.reverse(_.sortBy(sortedInstanceDefinitions, [sortCriteria]));
		//console.log("SORTED", sortCriteria, sortedInstanceDefinitions);

		_.reverse(instanceDefinitions).forEach(instanceDefinition => {
			if (!instanceDefinition.hasOwnProperty(sortCriteria) || instanceDefinition[sortCriteria] === null) {
				sortedInstanceDefinitions.push(instanceDefinition);
			}
		});

		tree.set(PlayerPaths.SORTED_SESSIONS, sortedInstanceDefinitions);
	} else {
		tree.set(PlayerPaths.SORTED_SESSIONS, []);
	}
}

export function itemSelected(tree, listIndex, sectionIndex, itemIndex) {
	let selectedListIndex = tree.get(PlayerPaths.ACTIVITY_SELECTED_LIST_INDEX);
	let selectedSectionIndex = tree.get(PlayerPaths.ACTIVITY_SELECTED_SECTION_INDEX);
	let selectedItemIndex = tree.get(PlayerPaths.ACTIVITY_SELECTED_ITEM_INDEX);
	if (selectedListIndex === listIndex && selectedSectionIndex === sectionIndex && selectedItemIndex === itemIndex) {
		return true;
	} else {
		return false;
	}
}

export function setSelectedItem(tree, listIndex, sectionIndex, itemIndex, autoScroll = false, speakSection = false) {
	// Need to deal with visible
	let resultFindItemVisible = findItemVisible(tree, { listIndex: listIndex, sectionIndex: sectionIndex, itemIndex: itemIndex });
	if (resultFindItemVisible !== null) {

		if (!listIndex && !sectionIndex) {
			setCompletionState(tree, 0, 0, 0);
		}

		listIndex = resultFindItemVisible.listIndex;
		sectionIndex = resultFindItemVisible.sectionIndex;
		itemIndex = resultFindItemVisible.itemIndex;

		console.log("In setSelectedItem: " + listIndex + "; " + sectionIndex + "; " + itemIndex + "; " + speakSection);

		const hasPrevious = listIndex > 0 || sectionIndex > 0 || itemIndex > 0; // Anything aside of the first item
		const lastItem = _.last(flattenedActivity).node;
		let hasNext = false;
		if (lastItem) {
			hasNext = listIndex !== lastItem.listIndex || sectionIndex !== lastItem.sectionIndex || itemIndex !== lastItem.itemIndex;
		}
		tree.set(PlayerPaths.ACTIVITY_PROPERTY("hasNext"), hasNext);
		tree.set(PlayerPaths.ACTIVITY_PROPERTY("hasPrevious"), hasPrevious);

		// Clear selected from whatever is currently selected
		let selectedListIndex = tree.get(PlayerPaths.ACTIVITY_SELECTED_LIST_INDEX);
		let selectedSectionIndex = tree.get(PlayerPaths.ACTIVITY_SELECTED_SECTION_INDEX);
		let selectedItemIndex = tree.get(PlayerPaths.ACTIVITY_SELECTED_ITEM_INDEX);

		tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(selectedListIndex, selectedSectionIndex, selectedItemIndex, "selected"), false);

		tree.set(PlayerPaths.ACTIVITY_PROPERTY("selectedListIndex"), listIndex);

		tree.set(PlayerPaths.ACTIVITY_SELECTED_LIST_INDEX, listIndex);
		tree.set(PlayerPaths.ACTIVITY_SELECTED_SECTION_INDEX, sectionIndex);
		tree.set(PlayerPaths.ACTIVITY_SELECTED_ITEM_INDEX, itemIndex);
		tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, itemIndex, "selected"), true);

		// let previousItem = tree.get(PlayerPaths.ACTIVITY_ITEM(selectedListIndex, selectedSectionIndex, selectedItemIndex));
		// let nextItem = tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, itemIndex));

		/*
		if (
			(previousItem.type.startsWith("itemTextInput") || previousItem.type.startsWith("itemBarcodeScanner"))
			&& global.inputs[selectedListIndex + "_" + selectedSectionIndex + "_" + selectedItemIndex]
			&& (!nextItem.type.startsWith("itemTextInput") && !nextItem.type.startsWith("itemBarcodeScanner"))) {
			setTimeout(function () {
				if (global.inputs[selectedListIndex + "_" + selectedSectionIndex + "_" + selectedItemIndex] !== null) {
					global.inputs[selectedListIndex + "_" + selectedSectionIndex + "_" + selectedItemIndex].blur();
				}
			}, 0);
		} else if (nextItem.type.startsWith("itemTextInput") || nextItem.type.startsWith("itemBarcodeScanner")) {
			// Try for 3 seconds
			if (tries === 30) {
				console.log("*** EXHAUSETED NUMBER OF TRIES");
				return false;
			} else if (global.inputs[listIndex + "_" + sectionIndex + "_" + itemIndex] === null) {
				console.log("*** TRY AGAIN " + tries);
				// Try again
				setTimeout(function () {
					setSelectedItem(tree, listIndex, sectionIndex, itemIndex, autoScroll, speakSection, tries++);
				}, 100);
			} else {
				if (!global.inputs[listIndex + "_" + sectionIndex + "_" + itemIndex].isFocused()) {
					setTimeout(function () {
						if (global.inputs[listIndex + "_" + sectionIndex + "_" + itemIndex] != null) {
							global.inputs[listIndex + "_" + sectionIndex + "_" + itemIndex].focus();
						}
					}, 0);
				}
			}
		}
		*/

		ensureExpanded(tree, listIndex, sectionIndex);
		if (autoScroll) {
			//ActionsLM.setScrollPos(tree, listIndex, sectionIndex, itemIndex);
		}

		return true;
	} else {
		return false;
	}
}

export function setNextSelected(tree, listIndex, sectionIndex, itemIndex) {
	console.log("In setNextSelected: " + listIndex + "; " + sectionIndex + "; " + itemIndex);

	// If the current section is not complete then prompt
	// let currentList = tree.get(PlayerPaths.ACTIVITY_LIST(listIndex));
	// let currentSection = tree.get(PlayerPaths.ACTIVITY_SECTION(listIndex, sectionIndex));

	// let item;

	if (findNextItemNotChecked(tree)) {
		// TODO: Not ideal...really need to figure out recursion with good return values
		console.log(" >>>> RESULT FIND ITEM", resultFindItem);
		if (typeof resultFindItem.listIndex !== "undefined" && typeof resultFindItem.sectionIndex !== "undefined" && typeof resultFindItem.itemIndex !== "undefined") {
			//if (tree.get(["moveForward"]) || (listIndex === resultFindItem.listIndex && sectionIndex === resultFindItem.sectionIndex) || currentSection.completionState === "c") {

			let resultListIndex = resultFindItem.listIndex;
			let resultSectionIndex = resultFindItem.sectionIndex;
			let resultItemIndex = resultFindItem.itemIndex;


			if (resultListIndex !== listIndex || resultSectionIndex !== sectionIndex) {
				setCompletionState(tree, resultListIndex, resultSectionIndex, resultItemIndex);
			}


			if (listIndex !== resultListIndex) {
				setSelectedListIndex(tree, resultFindItem.listIndex);
			}

			ensureExpanded(tree, resultListIndex, resultSectionIndex);
			setSelectedItem(tree, resultListIndex, resultSectionIndex, resultItemIndex, true);
			//} else {
			//showPromptModalMoveForward(tree);
			//}
		}
	}
}

// Could refactor to use flattenActivity
// Should be able to combine this function and findItemVisible
let resultFindItem;
let firstFindItem;

// Find next item not checked and not a labelOnly
function findNextItemNotChecked(tree, nextItem = null) {
	let lists = tree.get(PlayerPaths.ACTIVITY_PROPERTY("children"));
	resultFindItem = {};
	firstFindItem = true;

	if (nextItem === null) {
		nextItem = getNextItem(tree);
	}

	if (nextItem !== null) {
		findNextItemNotCheckedRecurse(lists, tree, 0, 0, 0, nextItem.listIndex, nextItem.sectionIndex, nextItem.itemIndex);
		return true;
	} else {
		return false;

		/*
		var selectedListIndex = tree.get(["activity", "selectedListIndex"]);
		var selectedSectionIndex = tree.get(["activity", "selected", "sectionIndex"]);

		// Find any unchecked in current section
		if (!tree.get(["moveForward"]) && findNextItemNotChecked(tree, { listIndex: selectedListIndex, sectionIndex: selectedSectionIndex, itemIndex: 0 })) {
			var item = tree.get(["activity", "children", nextItem.listIndex, "children", nextItem.sectionIndex, "children", nextItem.itemIndex]);
			if (Utils.isVisible(item)) {
				if (typeof resultFindItem.listIndex !== 'undefined' && typeof resultFindItem.sectionIndex !== 'undefined' && typeof resultFindItem.itemIndex !== 'undefined') {
					// var listIndex = resultFindItem.listIndex;
					// var sectionIndex = resultFindItem.sectionIndex;
					// var itemIndex = resultFindItem.itemIndex;

					// setSelectedItem(tree, listIndex, sectionIndex, itemIndex, true);

					return true;
				} else {
					return false;
				}
			} else {
				return false;
			}
		} else {
			//alert("You are at the end of the activity.");
			return false;
		}
		*/
	}
}

function findNextItemNotCheckedRecurse(arr, tree, listIndex, sectionIndex, itemIndex, baseListIndex, baseSectionIndex, baseItemIndex) {
	for (let i = 0; i < arr.length; i++) {
		if (arr[i].type === "list") {
			listIndex = i;
		} else if (arr[i].type === "section") {
			sectionIndex = i;
		} else if (arr[i].type.startsWith("item")) {
			let larger = false;
			if (listIndex > baseListIndex) {
				larger = true;
			} else if (listIndex === baseListIndex && sectionIndex > baseSectionIndex) {
				larger = true;
			} else if (listIndex === baseListIndex && sectionIndex === baseSectionIndex && i >= baseItemIndex) {
				larger = true;
			}

			//if (!arr[i].checked && !arr[i].labelOnly && !arr[i].skipped && larger) {
			if (!arr[i].checked && Utils.isVisible(arr[i]) && larger) {
				if (firstFindItem) {
					resultFindItem = {
						listIndex: listIndex,
						sectionIndex: sectionIndex,
						itemIndex: i
					};
					firstFindItem = false;
				}
			}
		}

		if (arr[i].hasOwnProperty("children") && Utils.isVisible(arr[i])) {
			findNextItemNotCheckedRecurse(arr[i].children, tree, listIndex, sectionIndex, itemIndex, baseListIndex, baseSectionIndex, baseItemIndex);
		}
	}
}

let flattenedActivity;
export function flattenActivity(tree) {
	let lists = _.cloneDeep(tree.get(PlayerPaths.ACTIVITY_PROPERTY("children")));
	flattenedActivity = [];
	flattenActivityRecurse(lists, tree, 0, 0);
}

function flattenActivityRecurse(arr, tree, listIndex, sectionIndex) {
	for (let i = 0; i < arr.length; i++) {
		if (arr[i].type === "list") {
			listIndex = i;
		} else if (arr[i].type === "section") {
			sectionIndex = i;
		} else if (arr[i].type.startsWith("item")) {
			let item = arr[i];
			let list = tree.get(PlayerPaths.ACTIVITY_LIST(listIndex));
			let section = tree.get(PlayerPaths.ACTIVITY_SECTION(listIndex, sectionIndex));
			// let visible = true;
			if (!Utils.isVisible(list)) {
				item.visible = false;
			} else if (Utils.isVisible(list) && !Utils.isVisible(section)) {
				item.visible = false;
			}
			flattenedActivity.push(
				{
					item: arr[i],
					node: {
						listIndex: listIndex,
						sectionIndex: sectionIndex,
						itemIndex: i
					}
				});
		}

		if (arr[i].hasOwnProperty("children")) {
			flattenActivityRecurse(arr[i].children, tree, listIndex, sectionIndex);
		}
	}
}

function getNextItem(tree) {
	let listIndex = tree.get(PlayerPaths.ACTIVITY_SELECTED_LIST_INDEX);
	let sectionIndex = tree.get(PlayerPaths.ACTIVITY_SELECTED_SECTION_INDEX);
	let itemIndex = tree.get(PlayerPaths.ACTIVITY_SELECTED_ITEM_INDEX);

	return findItemVisible(tree, { listIndex: listIndex, sectionIndex: sectionIndex, itemIndex: itemIndex }, true);
}

function getPreviousItem(tree) {
	let listIndex = tree.get(PlayerPaths.ACTIVITY_SELECTED_LIST_INDEX);
	let sectionIndex = tree.get(PlayerPaths.ACTIVITY_SELECTED_SECTION_INDEX);
	let itemIndex = tree.get(PlayerPaths.ACTIVITY_SELECTED_ITEM_INDEX);

	return findItemVisible(tree, { listIndex: listIndex, sectionIndex: sectionIndex, itemIndex: itemIndex }, true, true);
}

export function findItemVisible(tree, initialItem, startNext = false, backward = false) {
	// Right now flattening everytime finding new item
	// Need to think where can centralize. Will then need to keep in sync.
	flattenActivity(tree);
	let startIndex = null;

	if (backward) {
		for (let i = flattenedActivity.length - 1; i >= 0; i--) {
			let fi = flattenedActivity[i];
			if (fi.node.listIndex === initialItem.listIndex && fi.node.sectionIndex === initialItem.sectionIndex && fi.node.itemIndex === initialItem.itemIndex) {
				startIndex = i;
			}
		}

		startIndex = startNext ? backward ? (startIndex - 1) : (startIndex + 1) : startIndex;

		for (let j = startIndex; j >= 0; j--) {
			let fi = flattenedActivity[j];
			if (Utils.isVisible(fi.item)) {
				return fi.node;
			}
		}
	} else {
		for (let i = 0; i < flattenedActivity.length; i++) {
			let fi = flattenedActivity[i];
			if (fi.node.listIndex === initialItem.listIndex && fi.node.sectionIndex === initialItem.sectionIndex && fi.node.itemIndex === initialItem.itemIndex) {
				startIndex = i;
			}
		}

		startIndex = startNext ? (startIndex + 1) : startIndex;

		for (let j = startIndex; j < flattenedActivity.length; j++) {
			let fi = flattenedActivity[j];
			if (Utils.isVisible(fi.item)) {
				return fi.node;
			}
		}
	}


	return null;
}

export function setSelectedListIndex(tree, index) {
	let list = tree.get(PlayerPaths.ACTIVITY_LIST(index));
	if (index >= 0 && Utils.isVisible(list) && list.enabled) {
		// Need to centralize so only in one place
		tree.set(PlayerPaths.ACTIVITY_PROPERTY("selectedListIndex"), index);
		//tree.set(["activity", "selected", "listIndex"], index);
		refreshMandatory(tree);

		let currentList = tree.get(PlayerPaths.ACTIVITY_LIST_PROPERTY(index, "children"));

		let found = { type: "none" };
		getNextItemInSectionRecurse(currentList, index, found);

		if (found.type.startsWith("item")) {
			// let sectionCollapsed = tree.get(PlayerPaths.ACTIVITY_SECTION_PROPERTY(found.listIndex, found.sectionIndex, "collapsed"));

			//if (!sectionCollapsed) {
			//	setSelectedItemAndSave(tree, found.listIndex, found.sectionIndex, found.itemIndex, true);
			//}
		} else {
			setSelectedItem(tree, index, 0, 0, true);
		}
	} else {
		//setSpinnerVisible(tree, false);
	}
}

function getNextItemInSectionRecurse(arr, listIndex, found) {
	let sectionIndex;
	for (let i = 0; i < arr.length; i++) {
		if (arr[i].type === "section" && Utils.isVisible(arr[i])) {
			sectionIndex = i;

			if (arr[i].hasOwnProperty("children")) {
				getNextItemInSectionRecurse(arr[i].children, listIndex, found);
			}
		} else if (arr[i].type.startsWith("item")) {
			//if (found.type !== "item" && !arr[i].checked && !arr[i].labelOnly) {
			if (!found.type.startsWith("item") && Utils.isVisible(arr[i]) && !arr[i].checked) {
				found.type = "item";
				found.listIndex = listIndex;
				found.sectionIndex = sectionIndex;
				found.itemIndex = i;
			}
		}
	}
}

export function resetItem(tree, listIndex, sectionIndex, itemIndex) {
	console.log(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, itemIndex));
	let item = tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, itemIndex));

	switch (item.type) {
		case "itemImagePicker":
			tree.unset(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, itemIndex, "value"));
			tree.unset(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, itemIndex, "valueUrls"));
			break;
		case "itemSketchPad":
			tree.unset(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, itemIndex, "sketchPadImage"));
			tree.unset(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, itemIndex, "sketchPadImagePaths"));
			tree.unset(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, itemIndex, "sketchPadDimensions"));
			break;
		case "itemPicker":
		case "itemChoiceSingle":
		case "itemChoiceMulti":
		case "itemYesNo":
		case "itemDate":
		case "itemTime":
		case "itemDateTime":
		case "itemLocation":
		case "itemAddress":
		case "itemTextInput":
		case "itemTextInputMultiline":
			tree.unset(PlayerPaths.ACTIVITY_PROPERTY(listIndex, sectionIndex, itemIndex), "value");
			break;
		default:
			break;
	}

	tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, itemIndex, "checked"), false);
	// Reset visible from template
	// The template has all of the inital content
	// May be a better reset where everything we do comes from template

	// let activityTemplateIndex = getActivityIndexFromId(tree, tree.get(["activity"]).id);
	// let activityTemplate = tree.get(["activitys", activityTemplateIndex]);

	let activityTemplate = tree.get(PlayerPaths.ACTIVITY);

	let newItem = activityTemplate.children[listIndex].children[sectionIndex].children[itemIndex];
	let visible = true;
	if (!Utils.isVisible(newItem)) {
		visible = false;
	}
	tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, itemIndex, "visible"), visible);
}

export function getActivityIndexFromId(tree, id) {
	// console.log(" In " + arguments.callee.name);
	let activities = tree.get(["activities"]);

	for (let i = 0; i < activities.length; i++) {
		let activity = activities[i];

		if (activity.id === id) {
			return i;
		}
	}
	return -1;
}

export function ensureExpanded(tree, listIndex, sectionIndex) {
	if (!_.isUndefined(sectionIndex)) {
		tree.set(PlayerPaths.ACTIVITY_LIST_PROPERTY(listIndex, "expanded"), true);
		tree.set(PlayerPaths.ACTIVITY_SECTION_PROPERTY(listIndex, sectionIndex, "expanded"), true);
	} else {
		tree.set(PlayerPaths.ACTIVITY_LIST_PROPERTY(listIndex, "expanded"), true);
	}
}

export function toggleExpandNode(tree, listIndex, sectionIndex) {
	if (!_.isUndefined(sectionIndex)) {
		let expanded = tree.get(PlayerPaths.ACTIVITY_SECTION_PROPERTY(listIndex, sectionIndex, "expanded"));
		tree.set(PlayerPaths.ACTIVITY_SECTION_PROPERTY(listIndex, sectionIndex, "expanded"), !expanded);
	} else {
		let expanded = tree.get(PlayerPaths.ACTIVITY_LIST_PROPERTY(listIndex, "expanded"));
		tree.set(PlayerPaths.ACTIVITY_LIST_PROPERTY(listIndex, "expanded"), !expanded);
	}
}

export function expandAll(tree) {
	expandCollapseInternal(tree, true);
}

export function collapseAll(tree) {
	expandCollapseInternal(tree, false);
}

function expandCollapseInternal(tree, expanded) {
	let activity = tree.get(PlayerPaths.ACTIVITY);

	if (!_.isUndefined(activity.children)) {
		for (let i = 0; i < activity.children.length; i++) {
			let listItem = activity.children[i];
			if (listItem.type === "list") {
				tree.set(PlayerPaths.ACTIVITY_LIST_PROPERTY(i, "expanded"), expanded);
				if (!_.isUndefined(listItem.children)) {
					for (let j = 0; j < listItem.children.length; j++) {
						tree.set(PlayerPaths.ACTIVITY_SECTION_PROPERTY(i, j, "expanded"), expanded);
					}
				}
			}
		}
	}
}

export function listExpandAll(tree, listIndex) {
	listExpandCollapseInternal(tree, listIndex, true);
}

export function listCollapseAll(tree, listIndex) {
	listExpandCollapseInternal(tree, listIndex, false);
}

function listExpandCollapseInternal(tree, listIndex, expanded) {
	let list = tree.get(PlayerPaths.ACTIVITY_LIST(listIndex));

	tree.set(PlayerPaths.ACTIVITY_LIST_PROPERTY(listIndex, "expanded"), expanded);
	if (!_.isUndefined(list.children)) {
		for (let i = 0; i < list.children.length; i++) {
			let sectionItem = list.children[i];
			if (sectionItem.type === "section") {
				tree.set(PlayerPaths.ACTIVITY_SECTION_PROPERTY(listIndex, i, "expanded"), expanded);
			}
		}
	}
}

export function gotoItem(tree, listIndex, sectionIndex, itemIndex, selectList = false) {

	if (Utils.isValidItem(tree, listIndex, sectionIndex, itemIndex)) {
		// TODO: Need to test heaviliy by removing this!!!
		if (selectList) {
			setSelectedListIndex(tree, listIndex);
		}
		setSelectedItem(tree, listIndex, sectionIndex, itemIndex, true);
		ensureExpanded(tree, listIndex, sectionIndex);

		return true;
	} else {
		showError("Error", "Error trying to go to an invalid item.");
		return false;
	}
}

export function gotoNextItem(tree) {
	// console.log(" In " + arguments.callee.name);
	let item = getNextItem(tree);

	if (item !== null) {
		gotoItem(tree, item.listIndex, item.sectionIndex, item.itemIndex);
	}
}

export function gotoPreviousItem(tree) {
	// console.log(" In " + arguments.callee.name);
	let item = getPreviousItem(tree);

	if (item !== null) {
		gotoItem(tree, item.listIndex, item.sectionIndex, item.itemIndex);
	}
}

export function showSelectedItem(tree = state) {

	let listIndex = tree.get(["activity", "selected", "listIndex"]);
	let sectionIndex = tree.get(["activity", "selected", "sectionIndex"]);
	let itemIndex = tree.get(["activity", "selected", "itemIndex"]);

	setSelectedItem(tree, listIndex, sectionIndex, itemIndex, true, false);
}

export function clearCurrentActivityNoConfirm(tree, force = false) {
	let currentActivity = tree.get(["activity"]);
	if (currentActivity.hasOwnProperty("children") || (currentActivity && force)) {
		// alert("RESET");
		startNewActivity(tree, currentActivity);
	}
}

export function clearCurrentListNoConfirm(tree) {
	const listIndex = tree.get(["activity", "selectedListIndex"]);
	const list = tree.get(["activity", "children", listIndex]);

	let identityId = tree.get(["user"]).identityId;

	historyActions.clearList(tree, getActivityItemHistoryPath(listIndex, 0, 0), identityId, list);

	const listChildren = list.children;
	for (let i = 0; i < listChildren.length; i++) {
		const sectionChildren = listChildren[i].children;
		for (let j = 0; j < sectionChildren.length; j++) {
			resetItem(tree, listIndex, i, j);

			historyActions.uncheckItem(tree, getActivityItemHistoryPath(listIndex, 0, 0), identityId, tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, 0, 0)));

			setCompletionState(tree, listIndex, i, j);
		}
	}

	setDefaultValuesForList(tree, listIndex, 0, true);

	//saveCurrentActivityToStore(tree);

	refreshMandatory(tree);

	//setTimeout(function() {
	setSelectedItem(tree, listIndex, 0, 0, true);
	//},0);
}

export function clearCurrentSectionNoConfirm(tree) {
	const listIndex = tree.get(["activity", "selected", "listIndex"]);
	const sectionIndex = tree.get(["activity", "selected", "sectionIndex"]);

	const section = tree.get(["activity", "children", listIndex, "children", sectionIndex]);

	let identityId = tree.get(["user"]).identityId;

	historyActions.clearSection(tree, getActivityItemHistoryPath(listIndex, sectionIndex, 0), identityId, section);

	const sectionChildren = section.children;
	for (let i = 0; i < sectionChildren.length; i++) {
		resetItem(tree, listIndex, sectionIndex, i);

		historyActions.uncheckItem(tree, getActivityItemHistoryPath(listIndex, sectionIndex, 0), identityId, tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, 0)));

		setCompletionState(tree, listIndex, sectionIndex, i);
	}

	setDefaultValuesForSection(tree, listIndex, sectionIndex, true);

	//saveCurrentActivityToStore(tree);

	refreshMandatory(tree);

	//setTimeout(function() {
	setSelectedItem(tree, listIndex, sectionIndex, 0, true);
	//},0);
}

function clearItems(tree, startItemNode, endItemNode) {
	const lists = tree.get(["activity", "children"]);

	const startId = tree.get(["activity", "children", startItemNode.listIndex, "children", startItemNode.sectionIndex, "children", startItemNode.itemIndex, "guid"]);
	const endId = tree.get(["activity", "children", endItemNode.listIndex, "children", endItemNode.sectionIndex, "children", endItemNode.itemIndex, "guid"]);

	let identityId = tree.get(["user"]).identityId;

	historyActions.resetItemsInRange(tree, getActivityItemHistoryPath(endItemNode.listIndex, endItemNode.sectionIndex, endItemNode.itemIndex), identityId, tree.get(PlayerPaths.ACTIVITY));

	inClear = false;
	clearItemsRecurse(lists, tree, 0, 0, startId, endId);
}

let inClear;

function clearItemsRecurse(arr, tree, listIndex, sectionIndex, startId, endId) {
	for (let i = 0; i < arr.length; i++) {
		if (arr[i].type === "list") {
			listIndex = i;
		} else if (arr[i].type === "section") {
			sectionIndex = i;
		} else if (arr[i].type.startsWith("item")) {
			if (arr[i].guid === startId) {
				inClear = true;
			}
			if (inClear) {
				resetItem(tree, listIndex, sectionIndex, i, true);
			}
			if (arr[i].guid === endId) {
				inClear = false;
			}

		}

		if (arr[i].hasOwnProperty("children")) {
			clearItemsRecurse(arr[i].children, tree, listIndex, sectionIndex, startId, endId);
		}
	}
}



export function linkUrl(tree, url, currentItem, linkOnCheck = false) {
	//let currentActivityIndex = getActivityIndexFromId(tree, tree.get(["activity"]).id);
	//console.log(" In " + arguments.callee.name);

	let activity = tree.get(PlayerPaths.ACTIVITY);

	let retVal = false;

	if (url.toLowerCase().startsWith("resetcurrentactivity")) {
		clearCurrentActivityNoConfirm(tree);
		return;
	} else if (url.toLowerCase().startsWith("resetcurrentlist")) {
		clearCurrentListNoConfirm(tree);
		return;
	} else if (url.toLowerCase().startsWith("resetcurrentsection")) {
		clearCurrentSectionNoConfirm(tree);
		return;
	} else if (url.toLowerCase().startsWith("saveactivityandexit")) {
		saveActivityAndExit();
		return;
	} else if (url.toLowerCase().startsWith("opencomments")) {
		showComments(tree, 0);
		return;
	} else if (url.toLowerCase().startsWith("opennotes")) {
		showComments(tree, 1);
		return;
	} else if (url.toLowerCase().startsWith("openmedia")) {
		alert("Media attachments not supported in web player yet.");
		// showComments(tree, 2);
		return;
	} else if (url.toLowerCase().startsWith("opensketchpad")) {
		// showComments(tree, 3);
		alert("Sktechpad not supported in web player yet.");
		return;
	}


	if (url.toLowerCase().startsWith("goto:") ||
		url.toLowerCase().startsWith("newsessionandgoto:") ||
		url.toLowerCase().startsWith("gotoandreturn:") ||
		url.toLowerCase().startsWith("newsessionandgotoandreturn:") ||
		url.toLowerCase().startsWith("resetrangeandgoto:")) {

		let urlParts = url.split(":");

		// Test if have a activity to navigate to. If do, set the activityIndex.
		let pathParts = [urlParts[1]];
		let queryString = {};
		if (urlParts[1].indexOf("?") !== -1) {
			pathParts = urlParts[1].split("?");
			console.log("PARSING", pathParts[1]);
			queryString = qs.parse(pathParts[1]);
			console.log("PARSING result", queryString);
		}
		let path = pathParts[0];

		if (path === "") {
			setNextSelected(tree, currentItem.listIndex, currentItem.sectionIndex, currentItem.itemIndex);
			return;
		}

		pathParts = path.split(";");
		// let activityIndex = -1;
		let activityInternalId;

		let item;

		let hasActivity = false;
		let hasItem = false;
		let _activity = null;

		console.log(tree.get(["activities"]));
		var myActs = tree.get(["activities"]);

		if (pathParts.length > 1) {
			// Was causing very weird issue
			//let activities = tree.get(["activities"]);
			for (let i = 0; i < myActs.length; i++) {
				var myAct1 = myActs[i];
				if (myAct1.hasOwnProperty("checklistId") && myAct1.checklistId === pathParts[0]) {
					// Need to support deep linking to item
					_activity = myAct1;
					// activityIndex = i;
					hasActivity = true;
					activityInternalId = myAct1.id;
				}
			}

			hasItem = true;
			item = pathParts[1];
		} else {
			// Don't have activity
			if (pathParts[0].startsWith("#")) {
				hasItem = true;
				item = pathParts[0];
			} else {
				// Was causing very weird issue
				//let activities = tree.get(["activities"]);
				for (let i = 0; i < myActs.length; i++) {
					var myAct2 = myActs[i];
					if (myAct2.hasOwnProperty("checklistId") && myAct2.checklistId === pathParts[0]) {
						// Need to support deep linking to item
						_activity = myAct2;
						// activityIndex = i;
						hasActivity = true;
						activityInternalId = myAct2.id;
					}
				}
			}
		}

		// Do navigation
		if (hasActivity) {

			// let promise;

			let reset = _activity ? _activity.startInShowMode : queryString.reset ? queryString.reset : false;
			console.log("RESET?", queryString, reset, _activity);

			let newSession = false;
			if (url.toLowerCase().startsWith("newsessionandgoto:") || url.toLowerCase().startsWith("newsessionandgotoandreturn:")) {
				newSession = reset = true;
			}

			if (hasItem) {
				loadLinkedActivity(tree, activityInternalId, item, newSession);
			} else {
				loadLinkedActivity(tree, activityInternalId, undefined, newSession);
			}
			tree.set(["associatedContentCard"], {
				show: false
			});
			// promise.catch((err) => {
			// 	showError("Error", "Unable to go to link: " + err);
			// });

			// Fix function to return true or false
			retVal = true;
			// If jump within activity  
		} else {
			if (!_.isUndefined(item) && item !== null) {
				if (item.startsWith("#")) {
					if (url.toLowerCase().startsWith("newsessionandgoto:") || url.toLowerCase().startsWith("newsessionandgotoandreturn:")) {
						clearCurrentActivityNoConfirm(tree);
					}

					let newItem = tree.get(["idMap", item.substring(1)]);

					if (newItem !== null) {
						if (url.toLowerCase().startsWith("resetrangeandgoto:")) {
							let startItemNode = newItem;
							let endItemNode = currentItem;
							clearItems(tree, startItemNode, endItemNode);
						}

						//ensureExpanded(tree, newItem.listIndex, newItem.sectionIndex);
						retVal = gotoItem(
							tree,
							newItem.listIndex,
							newItem.sectionIndex,
							newItem.itemIndex
						);

						//var item = tree.get(["activity", "children", found.listIndex, "children", found.sectionIndex, "children", 0]);
						//let item = tree.get(["activity", "children", newItem.listIndex, "children", newItem.sectionIndex, "children", newItem.itemIndex]);

					} else {
						showError("Error", "The ID you are linking to could not be found.");
					}
				} else {
					showError("Error", "Invalid link.");
				}
			} else {
				showError("Error", "The ID you are linking to could not be found.");
			}
		}

		// Should I support two different stacks...one for activitys and one for items in activitys?
		if ((url.toLowerCase().startsWith("gotoandreturn:") || url.toLowerCase().startsWith("newsessionandgotoandreturn:")) && retVal) {
			let navStack = tree.select(PlayerPaths.NAV_STACK);
			if (hasActivity) {
				navStack.push({ activity: _.cloneDeep(activity), item: currentItem, linkOnCheck });
			} else {
				navStack.push({ item: currentItem, linkOnCheck });
			}
		}
	} else {
		Utils.openURL(url);
	}
}

export function showComments(tree, idx) {
	tree.set(["player", "showComments"], true);
	tree.set(["player", "showCommentsIdx"], idx ? idx : 0);
}

export function hideComments(tree) {
	tree.set(["player", "showComments"], false);
	tree.set(["player", "showCommentsIdx"], 0);
}

export function selectCommentsTab(tree, idx) {
	tree.set(["player", "showCommentsIdx"], idx ? idx : 0);
}

// Support linking to items, sections and lists as well as typical default URL behaviors
export function goBackDismiss(tree) {
	tree.set(PlayerPaths.NAV_STACK, []);
}

export function goBackFromLink(tree) {
	let navStack = tree.get(PlayerPaths.NAV_STACK);

	if (navStack.length > 0) {
		let newItem = navStack.pop();

		// If a different activity
		if (newItem.hasOwnProperty("activity")) {
			// Need to support deep linking
			//setCurrentActivityFromStore(tree, newItem.activityIndex, null, false, null, newItem.linkOnCheck, hideShowMode);			
			goBackFromLinkedActivity(tree, newItem.activity);
		} else {
			gotoItem(
				tree,
				newItem.item.listIndex,
				newItem.item.sectionIndex,
				newItem.item.itemIndex
			);
		}

		tree.set(PlayerPaths.NAV_STACK, navStack);
	}
}

export function setNotes(tree, listIndex, sectionIndex, itemIndex, notes, saveHistory = true) {
	tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, itemIndex, "notes"), notes);
	if (saveHistory) {
		let item = tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, itemIndex));
		let identityId = tree.get(["user"]).identityId;
		historyActions.setNotes(tree, listIndex + "," + sectionIndex + "," + itemIndex, notes, identityId, item);
	}
}

export function setSelectedHomeTab(tree, tab) {
	tree.set(PlayerPaths.SELECTED_HOME_TAB, tab);
}

export async function initWebPlayer(tree, params) {

	//delete config, override with params
	Utils.deleteAllObjectKeys(config);
	let _globalConfig = {};
	try {
		_globalConfig = globalConfig ? globalConfig : {};//eslint-disable-line
	} catch (e) {
		console.warn(e);
	}
	_.merge(config, params.config, _globalConfig);



	//delete env, override with params
	Utils.deleteAllObjectKeys(env);
	_.merge(env, params.env);

	let activities = params.activities;

	//set new state using passed in initial state prop
	state.set(params.state.get());

	console.log("WEB PLAYER INITIALIZE", params);
	// Initialize the drive tree
	if (params.hasOwnProperty("drive") && params.drive) {
		initializeDrive(params.drive);
	}

	Utils.deleteAllObjectKeys(ambifi);
	ambifi.playerCallbacks = {};
	ambifi.playerCallbacks = params.playerCallbacks;

	//Initialize persistence
	let targetConfig = config.persistence;

	ambifi.persistenceManager = PersistenceManagerFactory.buildFromConfig(targetConfig);

	state.set(["appState", "targetConfig"], targetConfig);

	//clear theme cache when creating new instance of player
	Utils.clearThemeCache();

	try {
		await ambifi.persistenceManager.init({
			activities,
			activityId: params.activityId,
			activityInstanceId: params.activityInstanceId
		});

		let activity = state.get(PlayerPaths.ACTIVITY);

		if (!_.isEmpty(activity) && !_.isUndefined(activity)) {

			resolveActivityFonts(activity);

			historyActions.openActivity(state, state.get(["user"]).identityId, state.get(PlayerPaths.ACTIVITY));

			await ambifi.persistenceManager.setCompletionState("incomplete");

			injectCustomStyling();

			//if expand all do it here
			if (state.get(["_config", "expandAllOnLoad"]) === true) {
				expandAll(state);
			}

			if (params.playerCallbacks.onLoad) {
				params.playerCallbacks.onLoad();
			}
		} else {
			if (params.playerCallbacks.onLoadError) {
				params.playerCallbacks.onLoadError(new Error(`Unable to load activity: ${params.activityId}, instanceId: ${params.activityInstanceId}`));
			}
		}

		state.set(["loaded"], true);
	} catch (err) {
		if (params.playerCallbacks.onLoadError) {
			params.playerCallbacks.onLoadError(err);
		}
	}
}

/**
 * Loads activity from activities collection when all activities are loaded at once
 * as a published array of JSON objects
 * 
 * @param {*} activityId 
 * @param {*} initialItemId 
 */
export function loadPublishedActivity(activityId, initialItemId) {

	let activities = state.get(PlayerPaths.ACTIVITIES);

	let activity = _.find(activities, { id: activityId });

	//put current activity back into array
	let currentActivity = state.get(PlayerPaths.ACTIVITY);
	let currentActivityIdx = _.findIndex(activities, { id: currentActivity.id });

	state.set(["activities", currentActivityIdx], currentActivity);

	initializeActivity(state, activity, initialItemId);

	return activity;
}

/*
export function handleChangeProperty(tree, listIndex, sectionIndex, itemIndex, name, value) {
	if (name !== "value") {
		handleChangePropertyDisconnected(tree, listIndex, sectionIndex, itemIndex, name, value);
	} else {
		let item = tree.get(["activity", "children", listIndex, "children", sectionIndex, "children", itemIndex]);
		console.log("IFTTT VARIABLE VALUE SET REQUEST - handleChangeProperty");
		setValueIfHasIdOrchestratedSync(item, value).then(() => {


			tree.set(["activity", "children", listIndex, "children", sectionIndex, "children", itemIndex, name], value);
			saveLastItemValue(tree, value);
			tree.commit();

			// Moved this down as it might be looking at the node value
			if (item.hasOwnProperty("valueTrigger") && item.valueTrigger !== "") {
				// Inject global procedure functions
				let strfun = tree.get(["activity", "functions"]);
				if (strfun !== "") {
					eval(strfun);
				}
				let AmbiFi = RuntimeApi;
				eval(item.valueTrigger);
				//tree.set(["session"], tree.get(["session"]) + 1);
			}
		});
	}
}

export function handleChangeBarcodeProperty(tree, listIndex, sectionIndex, itemIndex, value) {
	let item = tree.get(["activity", "children", listIndex, "children", sectionIndex, "children", itemIndex]);
	tree.set(["activity", "children", listIndex, "children", sectionIndex, "children", itemIndex, "barcode", "data"], value);

	tree.commit();
}
*/

export function hideAssociatedContentCard() {
	state.set(["associatedContentCard"], { show: false });
}

export function showAssociatedContentCard(item, template, targetStyles, targetTextStyles, listIndex, sectionIndex, itemIndex) {
	try {
		const _template = Handlebars.compile(template, { noEscape: true });
		const renderedAssociatedContent = _template({ data: item.associatedContent });

		state.set(["associatedContentCard"], {
			show: true,
			stage: 0,
			associatedContent: item.associatedContent,
			template,
			renderedAssociatedContent,
			targetStyles,
			label: item.label,
			targetTextStyles,
			listIndex,
			sectionIndex,
			itemIndex
			// overrideRules
		});
	} catch (e) {
		console.error(e);
		// Alert.alert(
		// 	'Render Associated Content',
		// 	'An error occurred while attempting to render the associated content.');
	}

}

export function increaseStage() {
	state.set(["associatedContentCard", "stage"], state.get(["associatedContentCard", "stage"]) + 1);
}

export function resolveActivityFonts(activity) {

	if (activity.fonts) {
		//clear out previous activity links
		let head = document.getElementsByTagName("head")[0];
		let elementsToRemove = [];

		for (let i = 0; i < head.childNodes.length; i++) {
			let node = head.childNodes[i];
			if (node.nodeName.toLowerCase() === "link" && node.getAttribute("data-activity-fonts-css") === "true") {
				elementsToRemove.push(node);
			}
		}

		for (let i = 0; i < elementsToRemove.length; i++) {
			head.removeChild(elementsToRemove[i]);
		}

		//create DOM and append links to head
		let el = document.createElement("head");
		el.innerHTML = "<head>" + activity.fonts + "</head>";

		let links = el.childNodes;

		for (let i = 0; i < links.length; i++) {
			//need to clone because this link has different parent than actual head element
			let link = links[i];
			if (link.nodeName.toLowerCase() === "link") {
				let newLink = document.createElement("link");
				newLink.setAttribute("href", link.getAttribute("href"));
				newLink.setAttribute("rel", link.getAttribute("rel"));
				newLink.setAttribute("data-activity-fonts-css", true);
				head.appendChild(newLink);
			}
		}
	}
}